export const END_POINTS = {
  NEWS: "api/News",
  LATEST_NEWS: "api/News/GetLatestNews",
  NEWS_SEARCH: "api/News/Search",
  CONTACT_US: "api/NewsCategory",
  CAPMAS_HEAD: "api/CapmasHead",
  MISSION_VISION: "api/MissionVision",
  MAIN_VALUE: "api/MainValue",
  SECTORS: "api/Sector",
  ELEMENT: "api/Element",
  HISTORY: "api/CapmasHistory",
  LAWS: "api/LawRegulation",
  IMAGE_ORGANIZATIONAL_CHART: "api/OrganizationalChart",
  USAGE_RIGHT_TERM: "api/UsageRightAndTerm",
  NEWS_CATEGORIES: "api/Category",
  REGIONAL_OFFICE: "api/RegionalOffice",
  REGIONAL_OFFICE_SEARCH: "api/RegionalOffice/Search",
  REGIONAL_OFFICE_MAIN_BRANCH: "api/RegionalOffice/GetMainBranchLocation",
  ADDITIONAL_OFFICE: "api/AdditionalOffice",
  GOVERNORATES: "api/Governorate",
  PINNED_PHOTOS: "api/Photo/PinnedPhotos",
  PHOTO_ALBUM: "api/PhotoAlbum",
  PHOTO_ALBUM_DETAILS: "api/PhotoAlbum/PhotoAlbumWithPhoto",
  PHOTO_CATEGORIES: "api/PhotoCategory",
  NEWS_GET_MOST_VIEWED: "api/News/GetMostViewedNews",
  NEWS_GET_LATEST: "api/News/GetLatestNews",
  NEWS_GET_PINNED: "api/News/GetPinnedNews",
  NEWS_GET_RELATED: "api/News/GetRelatedNews",
  VIDEO_LIBRARY: "api/VideoLibrary/VideoLibrary",
  RADIO_LIBRARY: "api/VideoLibrary/RadioLibrary",
  EGYPT_STATISTICS_JOURNAL: "api/EgyptStatisticsJournal",
  SERVICES_TOOLS: "api/ServiceAndTool",
  RELATED_WEBSITES: "api/RelatedWebsite",
  WEBSITE_TYPES: "api/WebsiteType",
  SERVICES_HOME: "api/ServiceAndTool/GetHomeTools",
  NEWS_BAR: "api/NewsBar",
  API_SLIDER: "api/Slider",
  SUBJECTS: "api/Subject",
  SUBJECTS_WITH_DATA: "api/Subject/HasData",
  SUBJECT_DETAILS: "api/Subject/SubSubjectWithIndicator",
  SUBJECT_VISUALIZATION: "api/Subject/SubSubject",
  VISUALIZATION_DETAILS: "api/Indicator/IndicatorDetails",
  API_POPULATION: "api/EgyptPopulation",
  API_POPULATION_BY_COUNTRY: "api/GovernoratePopulation",
  API_MIN_MAX_BY_COUNTRY: "api/GovernoratePopulation/MinAndMaxDate",
  API_PRICES: "api/Publication/PublicationPrice",
  API_MONTH_CALENDAR: "api/Calendar/GetMonthCalendar",
  API_DAY_CALENDAR: "api/Calendar/GetDayCalendar",
  PUBLICATIONS: "api/Publication/Search",
  PUBLICATION_DETAILS: "api/Publication",
  COUNTRY: "api/Country",
  SUBSCRIPTION_TYPE: "api/SubscriptionType",
  CURRENT_EGYPT_POPULATION: "egpop",
  EGYPT_POPULATION_BY_DATE: "api/EgyptPopulation",
  PUBLICATION_TYPE: "api/admin/Lookup/PublicationTypes",
  PERIODICS: "api/admin/Lookup/Periodics",
  MAIN_SUBJECTS: "api/admin/Lookup/MainSubjects",
  SUB_SUBJECTS: "api/admin/Lookup/SubSubjects",
  INDICATOR_FILTER: "api/Indicator/IndicatorFilter",
  SERVICE_TYPE: "api/ServiceType",
  AGENCY_TYPE: "api/AgencyType",
  FILM_TYPE: "api/FilmType",
  EVIDENCE_CLASSIFICATIONS: "api/EvidenceAndClassification",
  HOME_CALENDAR: "api/Calendar/GetHomeCalendar",
  HOME_PUBLICATION_DETAILS: "api/PublicationDetail/HomePublicationDetail",
  RELATED_PUBLICATION_DETAILS:
    "api/Publication/RelatedPublication?publicationId",
  LOGIN: "api/Auth/Login",
  REFRESH_TOKEN: "api/Auth/RefreshToken",
  API_LOGOUT: "api/Auth/Logout",
  INFOGRAPH: "api/Infographic/Infographic?publicationDetailId",
  IMPORTANT_PORTAL: "api/ImportantPortal",
  SURVEY_CENSUSE: "api/SurveyCensuse",
  SURVEY_HOME: "api/Survey/HomeSurvey",
  SURVEY_VOTE: "api/Survey/SurveyVote",
  LATEST_VIDEO: "api/VideoLibrary/LatestVideo",
  LATEST_PHOTO: "api/Photo/LatestPhoto",
  PUBLICATION_PERIODS: "api/Publication/PublicationPeriods?publicationId",
  SEARCH_PUBLICATION_DETAILS:
    "api/Publication/SearchPublicationDetail?PublicationId",
  FOOTER_SITE_SELECTION: "api/SiteSelection",
  FOOTER_CONTACT_US: "api/ContactUs",
  SUBJECT_SEARCH: "api/Subject/Search",
  HAPPENING_NOW: "api/HappeningNow",
  SERVICES_TOOLS_DEPARTMENT: "api/ServiceAndTool/ToolAndServiceDepartment?id",
  CALENDER_DEPARTMENT_ID: "11",
  REGISTER_DEPARTMENT_ID: "13",
  PRICES_DEPARTMENT_ID: "15",
  NEWSLETTERS_DEPARTMENT_ID: "16",
  DATA_REQUEST_DEPARTMENT_ID: "18",
  MICROFILM_DEPARTMENT_ID: "19",
  NATIONAL_CENTER_ID: "21",
  API_SEARCH_TERM: "api/Home/ContentTitleSearch",
  NEWS_SEARCH_TERM: "api/Home/NewsContentTitleSearch",
  PUBLICATIONS_SEARCH_TERM: "api/Home/PublicationsContentTitleSearch",
  INDICATORS_SEARCH_TERM: "api/Home/IndicatorsContentTitleSearch",
  ADVANCED_SEARCH: "api/Home/FullContentTitleSearch",
  NEWS_ADVANCED_SEARCH: "api/Home/NewsFullContentTitleSearch",
  PUBLICATIONS_ADVANCED_SEARCH: "api/Home/PublicationFullContentTitleSearch",
  INDICATORS_ADVANCED_SEARCH: "api/Home/IndicatorFullContentTitleSearch",
  SOCIAL_LINK: "api/SocialLink",
  NEW_TOOLS: "api/ServiceAndTool/GetNewTools",
  GET_PHOTO_BY_ID: "api/MediaUploader/GetPhotoByGUID",
  GET_ALL_CHAPTERS: "api/admin/Lookup/Chapters",
  GET_ALL_SUB_CHAPTERS: "api/admin/Lookup/SubChapters",
  GET_SUB_CHAPTERS_BY_ID: "api/admin/Chapters/GetChapterById?id=",
  ITEM_GUIDE: "api/admin/Items/ItemGuide",
  SEASONS: "api/admin/Chapters/ChapterReport",
  COUNTRY_ITEM_REPORT: "api/admin/Countries/CountryItemReport",
  COUNTRIES: "api/admin/Lookup/Countries",
  COUNTRIES_REPORT: "api/admin/Countries/CountryReport",
  TOTALS_REPORT: "api/admin/Total/TotalsReport",
  ITEMS: "api/admin/Lookup/Items?searchTerm=",
  ITEMS_REPORT: "api/admin/Items/GetItemsReport",
  FORGET_PASS: "api/Auth/ForgotPassword",
  RESET_CODE: "api/Auth/ResetCode",
  RESET_PASS: "api/Auth/ResetPassword",
  EXECUTE_FORGOT_PASS: "api/Auth/ExecuteForgotPassword",
  SELECTED_INDICATOR: "api/SelectedIndicator",
  TRAINING_PROGRAM_LOOKUP: "api/TrainingProgram/LookUp",
  DATA_REQUEST: "api/DataRequest",
  MICROFILM: "api/MicroFilmData",
  TRAINING_PROGRAM_ADD: "api/TrainingRequest/Add",
  REGISTER: "api/auth/RegisterUser",
  PUBLICATION_SUBSCRIPTION: "api/PublicationSubscription",
  PINNED_INDICATORS: "api/PinedIndicator/IndicatorFilter",
  USAGE:
    "api/admin/Usage_Manufacturing_Degrees_/UsageManufacturingDegreesReport",
  IMPORT_EXPORT: "api/admin/Companies/ExportersAndImportersReport",
  SUB_CHAPTERS_REPORT: "api/admin/SubChapters/GetSubChapterReport",
  TRADE_BALANCE_REPORT: "api/admin/TradeBalance/Report",
  REGIONS: "api/admin/Lookup/Regions",
  ECONOMIC_GROUP: "api/admin/Lookup/EconomincGroups",
  YEAR_MONTH_LOOKUP: "api/admin/Lookup/YearMonthData",
  USAGE_LOOKUP: "api/admin/Lookup/DegreeOfUse",
  IP_ADDRESS: "https://api.ipify.org?format=json",
  GET_USER_DATA: "api/User/me",
  UPDATE_USER_DATA: "api/User/UpdateUserProfile",
  GET_ALL_PUBLICATIONS: "api/Subject/Publications",
  PUBLICATION_SUBSCRIPTION_BULK: "api/PublicationSubscription/Bulk",
  USER_PUBLICATION_SUBSCRIPTIONS: "api/PublicationSubscription",
  EMAIL_VERIFICATION: "api/Auth/VerifyEmailCode",
  TRACKING_ID: "G-CR5TYG9F3F",
};
